export enum UserLoginData {
  token = "1",
  user_name = "2",
  user_id = "3",
  organization_id = "4",
  currency_symbol = "5",
  tenant_id = "6",
  permissions = "7"
}